export function AnnouncementBar() {
  return (
    <div
      data-testid="announcement-bar"
      className="relative z-50 flex items-center justify-center gap-3 border-b border-white/10 bg-[#0e131f] px-4 py-2 text-center"
    >
      <span className="h-1.5 w-1.5 rounded-full bg-cyan-400 animate-pulse-soft" />
      <p className="font-mono text-[10px] sm:text-[11px] tracking-[0.22em] uppercase text-slate-300">
        Launch week <span className="text-slate-600">/</span> Instant PDF download{" "}
        <span className="text-slate-600">/</span> <span className="text-amber-400">70% off today</span>
      </p>
    </div>
  );
}
